// A person's own theme and mode, and a facility's default theme (ADR 0030). Anyone signed in
// may change their own; the facility default needs admin.facilities.manage, which the API
// checks.
import {
  appearanceSchema,
  facilitySchema,
  type ThemeId,
  type UpdateAppearanceBody,
} from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';

import { api } from './client.ts';

export const appearanceQuery = queryOptions({
  queryKey: ['me', 'appearance'],
  queryFn: () => api('GET', '/me/appearance', { schema: appearanceSchema }),
});

export function updateAppearance(body: UpdateAppearanceBody) {
  return api('PUT', '/me/appearance', { body, schema: appearanceSchema });
}

export function setFacilityDefaultTheme(facilityId: string, theme: ThemeId) {
  return api('PUT', `/facilities/${facilityId}/default-theme`, {
    body: { theme },
    schema: facilitySchema,
  });
}
